$(function () {
    "use strict";
    // jQuery load
    $(document).ready(function () {
        // Inner page accordion
        $(".custom-accordion__header").on("click", function() {
            var parent = $(this).closest(".custom-accordion__item");
            parent.siblings().removeClass("active");
            var body = $(this).next();
            var bodyInner = body.find(".custom-accordion__body--inner");
            var bodyHeight = body.innerHeight();
            var currentIsActive = parent.hasClass('active');
            if (currentIsActive) {
                let collapseInterval = setInterval(() => {
                    if (bodyHeight >= 0) {
                        bodyHeight = bodyHeight - 10;
                        body.css("height", bodyHeight + 'px');
                        body.css("overflow", 'hidden');
                    } else {
                        body.css("height", 0);
                        body.css("overflow", 'hidden');
                        parent.removeClass("active");
                        clearInterval(collapseInterval);
                    }
                }, 0);
            } else {
                let collapseInterval = setInterval(() => {
                    if (bodyHeight <= bodyInner.innerHeight()) {
                        bodyHeight = bodyHeight + 10;
                        body.css("height", bodyHeight + 'px');
                    } else {
                        clearInterval(collapseInterval);
                        parent.addClass("active")
                        body.removeAttr('style');
                    }
                }, 0);
            }
        })

        // Custom modal
        $(".modal-trigger").on("click", function() {
            let ariaAttribute = $(this).attr("aria-modal");
            let modal = document.getElementById(ariaAttribute);
            modal.classList.add("active");
        })
        $(".modal-close").on("click", function() {
            let parent = $(this).closest(".custom-modal__wrapper");
            parent.removeClass("active");
        })

        // Image hover effect
        let visionImages = document.querySelectorAll(".our__vision_content img");
        visionImages.forEach((item) => {
            item.addEventListener('mouseover', (e) => {
                let position = e.target.getBoundingClientRect();
                let itemRightPosition = window.innerWidth - position.right;
                if (itemRightPosition < 15) {
                    item.style.transformOrigin = 'top right';
                } else {
                    item.style.transformOrigin = 'center';
                }
            })
            item.addEventListener('mouseout', (e) => {
                if (item.style.transformOrigin) {
                    item.style.removeProperty('transform-origin');
                }
            })
        })
    });
});